import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IncidentDashboardComponent } from './components/incident-dashboard/incident-dashboard.component';
import { RaiseIncidentComponent } from './components/raise-incident/raise-incident.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'incident-overview'
  },
  {
    path: 'report-incident/new',
    component: RaiseIncidentComponent
  },
  {
    path: 'report-incident/:incidentId',
    component: RaiseIncidentComponent
  },
  {
    path: 'incident-overview',
    component: IncidentDashboardComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})

export class IncidentRoutingModule { }
